import { MZCAPI } from './http-mzcapi'

async function getAppSettings (appId, token) {
  return MZCAPI.get(`/apps/${appId}/settings`, {
    headers: {
      Authorization: token,
      MZScope: 'with-children'
    }
  })
}

async function setAppSettings (store, settings) {
  let localSettings = store.getters.appConfig

  if (localSettings.version === undefined || localSettings.version < settings.version) {
    await store.dispatch('setAppConfig', settings)
  }
}

export default {
  async initializeApplicationSettings (store, defaultSettings) {
    let currentSettings = store.getters.appConfig

    if (!currentSettings.hasOwnProperty('version')) {
      await setAppSettings(store, defaultSettings)
    }

    try {
      let token = store.getters.getToken

      let response = await getAppSettings(defaultSettings.application_id, token)
      let settings = response.data

      await setAppSettings(store, settings)
    } catch (e) {
      console.error('Could not load application settings.', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/config.js